import { Box, Button, CardHero, type DeeplyNestedSx } from "@biom3/react";

export type SuccessButtonProps = {
  testId: string;
  label: string;
  sx?: DeeplyNestedSx;
};

export function SuccessButton({ testId, label, sx }: SuccessButtonProps) {
  return (
    <CardHero.Button
      testId={testId}
      sx={{
        backgroundColor: "#00FF94",
        color: "#131313",
        ...(sx || {}),
      }}
      variant="tertiary"
      disabled={true}
    >
      <Box>{label}</Box>
      <Button.Icon
        icon={"Tick"}
        fontWeight="bold"
        sx={{ w: { default: "base.icon.size.200" }, fill: "#131313" }}
      />
    </CardHero.Button>
  );
}
